var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.busy)?[_c('CenteredMessage',{attrs:{"spinner":_vm.busy}},[[_vm._v("Lädt Widget...")]],2)]:[(_vm.loaded)?_c('LineChart',{attrs:{"chartdata":_vm.chartData}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }